import { createFileRoute } from "@tanstack/react-router";

import { EventsPage } from "@/features/booking/modules/client-events/events-page";
import { eventsSearchSchema } from "@/features/booking/modules/client-events/event-filters";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/events/")({
  // The search lives in the URL, so a filtered view is linkable and survives a reload.
  validateSearch: eventsSearchSchema,
  loader: () => ({ crumb: m.booking_portal_tab_events() }),
  component: Events,
});

function Events() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <EventsPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
      onOpenSpecialists={() => void navigate({ to: "/book" })}
      onOpenBookings={(bookingId) => void navigate({ to: "/my-bookings", search: bookingId ? { bookingId } : {} })}
    />
  );
}
